import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p491706559778459648',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
